module.exports = __webpack_public_path__ + "img/icon296.5e982c8f.png";